import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"elevation":"0"}},[_c('CardView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }